import { SelMessage } from "@/messages/SelMessage.tsx";
import type { FileDownloadEvent } from "@/modules/notifications/utils/types.ts";
import { downloadPreparedFile } from "@/redux/modules/data-export.ts";
import { type ReduxDispatch } from "@/redux/redux-utils.ts";
import { type FC, useState } from "react";
import { useDispatch } from "react-redux";
import { ActionButton, ActionButtonIconPlacement, ActionButtonSize, Callout, CalloutIntent, VStack } from "widgets";

export interface FileDownloadNotificationProps {
  downloadEvent: FileDownloadEvent;
  onDownload: () => void;
}

export const FileDownloadNotification: FC<FileDownloadNotificationProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const filename = props.downloadEvent.fileName;
  const downloadKey: string = props.downloadEvent.fileKey;
  const [errorMessage, setErrorMessage] = useState<string>();

  return (
    <VStack>
      <div>
        <SelMessage id={"websocket.file.exportReady"} values={{ filename: filename }} />
      </div>
      <ActionButton
        icon={"download"}
        label={"Download"}
        size={ActionButtonSize.Small}
        iconPlacement={ActionButtonIconPlacement.Right}
        onPress={() =>
          dispatch(downloadPreparedFile(downloadKey))
            .then(props.onDownload)
            .catch((error: Error) => {
              setErrorMessage(error.message);
            })
        }
      />
      {errorMessage ? <Callout intent={CalloutIntent.Danger}>{errorMessage}</Callout> : null}
    </VStack>
  );
};
